import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { Float, Sparkles } from "@react-three/drei";

export const Ouroboros = ({ progress }) => {
  const ref = useRef();

  useFrame((_, d) => {
    const g = ref.current;
    if (!g) return;
    const p = progress ? progress.get() : 0;
    g.rotation.z = p * Math.PI * 2;
    g.rotation.x = 0.55 + p * 0.5;
    g.rotation.y += d * 0.08;
  });

  return (
    <>
      <ambientLight intensity={0.55} />
      <pointLight position={[3, 3, 4]} intensity={40} color="#C5A059" />
      <pointLight position={[-4, -3, -2]} intensity={18} color="#3B2A48" />
      <Float speed={1.1} rotationIntensity={0.15} floatIntensity={0.6}>
        <group ref={ref} rotation={[0.55, 0, 0]}>
          <mesh>
            <torusGeometry args={[2, 0.34, 48, 200]} />
            <meshStandardMaterial
              color="#C5A059"
              metalness={1}
              roughness={0.22}
              emissive="#3B2A48"
              emissiveIntensity={0.3}
            />
          </mesh>
          <mesh>
            <torusGeometry args={[2, 0.37, 10, 200]} />
            <meshBasicMaterial color="#C5A059" wireframe transparent opacity={0.12} />
          </mesh>
          <mesh rotation={[Math.PI / 2, 0, 0]}>
            <torusGeometry args={[2.55, 0.006, 12, 200]} />
            <meshBasicMaterial color="#C5A059" transparent opacity={0.4} />
          </mesh>
        </group>
      </Float>
      <Sparkles count={50} scale={8} size={2} speed={0.25} color="#C5A059" opacity={0.45} />
    </>
  );
};

export default Ouroboros;
